import { ArrowUp, ArrowDown, ArrowLeft, ArrowRight } from "react-feather";

export type ArrowDirection = 'up' | 'down' | 'left' | 'right' | 'none';

interface DirectionProps {
    direction: ArrowDirection
}

export function DirectionArrow({ direction }: DirectionProps) {
    let arrowIcon = null;
    let containerClass = '';
    switch (direction) {
        case 'left':
            containerClass = "top-1/2 right-full -translate-y-1/2 mr-1";
            arrowIcon = <ArrowLeft className="w-4 h-4" />;
            break;
        case 'right':
            containerClass = "top-1/2 left-full -translate-y-1/2 ml-1";
            arrowIcon = <ArrowRight className="w-4 h-4" />;
            break;
        case 'down':
            containerClass = "top-full left-1/2 -translate-x-1/2 mt-1";
            arrowIcon = <ArrowDown className="w-4 h-4" />;
            break;
        case 'up':
            containerClass = "bottom-full left-1/2 -translate-x-1/2 mb-1";
            arrowIcon = <ArrowUp className="w-4 h-4" />;
            break;
    }

    return (
        <div className={`absolute text-black ${containerClass}`}>
            {arrowIcon}
        </div>

    );
}

export function determineDirection(index: number, boardSize: number): ArrowDirection {
    const row = Math.floor(index / boardSize);
    const col = index % boardSize;

    const lastIndex = (boardSize % 2 === 1)
        ? (boardSize * boardSize) - 1
        : boardSize * (boardSize - 1);

    if (index === lastIndex) {
        return 'none';
    }

    const isEvenRow = row % 2 === 0;

    if (isEvenRow) {
        if (col < boardSize - 1) {
            return 'right';
        } else {
            return 'down';
        }
    } else {
        if (col > 0) {
            return 'left';
        } else {
            return 'down';
        }
    }
}